import React, { useEffect, useState, useRef } from 'react';
import { dashAPI, productAPI, orderAPI, returnAPI, walletAPI, dealAPI, profileAPI, notifAPI } from './SellerApi';

export const SellerProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [success, setSuccess] = useState('');
  const [error,   setError]   = useState('');
  const [tab,     setTab]     = useState('personal');

  useEffect(() => {
    profileAPI.get().then(r => setProfile(r.data)).catch(() => {
      const u = JSON.parse(localStorage.getItem('seller_user')||'{}');
      setProfile({ firstName: u.firstName||'', lastName: u.lastName||'', email: u.email||'', mobile: u.mobile||'', businessName: u.businessName||'', businessCategory: u.businessCategory||'', gst: u.gst||'', pan: u.pan||'', addressLine1: u.addressLine1||'', addressLine2: u.addressLine2||'', city: u.city||'', state: u.state||'Tamil Nadu', pincode: u.pincode||'' });
    }).finally(() => setLoading(false));
  }, []);

  const up = (k, v) => setProfile(p => ({ ...p, [k]: v }));

  const handleSave = async () => {
    setSaving(true); setError('');
    try {
      await profileAPI.update(profile);
      setSuccess('Profile updated!');
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  };

  if (loading || !profile) return <div className="sp-skeleton" style={{height:400,borderRadius:'var(--r-lg)'}} />;

  return (
    <div>
      {error   && <div className="sp-error">{error}</div>}
      {success  && <div className="sp-success">{success}</div>}

      <div style={{display:'flex',gap:'0.5rem',marginBottom:'1.5rem'}}>
        {['personal','business','address'].map(t => (
          <button key={t} onClick={()=>setTab(t)} style={{padding:'0.5rem 1.25rem',borderRadius:'50px',fontSize:13,fontWeight:600,background:tab===t?'var(--em-400)':'var(--s2)',color:tab===t?'var(--s0)':'var(--t2)',border:'1px solid var(--border-hi)',cursor:'pointer',transition:'var(--tr)',textTransform:'capitalize'}}>
            {t === 'personal' ? '👤 Personal' : t === 'business' ? '🏢 Business' : '📍 Address'}
          </button>
        ))}
      </div>

      <div className="sp-card">
        {tab === 'personal' && (
          <div>
            <div className="sp-card-title">Personal Information</div>
            <div className="sp-input-row">
              <div className="sp-input-group"><label className="sp-label">FIRST NAME</label><input className="sp-input" value={profile.firstName||''} onChange={e=>up('firstName',e.target.value)} /></div>
              <div className="sp-input-group"><label className="sp-label">LAST NAME</label><input className="sp-input" value={profile.lastName||''} onChange={e=>up('lastName',e.target.value)} /></div>
            </div>
            <div className="sp-input-row">
              <div className="sp-input-group"><label className="sp-label">EMAIL</label><input className="sp-input" type="email" value={profile.email||''} onChange={e=>up('email',e.target.value)} /></div>
              <div className="sp-input-group"><label className="sp-label">MOBILE</label><input className="sp-input" value={profile.mobile||''} readOnly style={{opacity:0.6}} /></div>
            </div>
            <div className="sp-input-row">
              <div className="sp-input-group"><label className="sp-label">PAN NUMBER</label><input className="sp-input" value={profile.pan||''} onChange={e=>up('pan',e.target.value.toUpperCase())} maxLength={10} /></div>
              <div className="sp-input-group"><label className="sp-label">GST NUMBER <span style={{fontSize:10,color:'var(--t3)'}}>Optional</span></label><input className="sp-input" value={profile.gst||''} onChange={e=>up('gst',e.target.value.toUpperCase())} maxLength={15} /></div>
            </div>
          </div>
        )}

        {tab === 'business' && (
          <div>
            <div className="sp-card-title">Business Information</div>
            <div className="sp-input-group"><label className="sp-label">BUSINESS / FARM NAME</label><input className="sp-input" value={profile.businessName||''} onChange={e=>up('businessName',e.target.value)} /></div>
            <div className="sp-input-group"><label className="sp-label">BUSINESS CATEGORY</label>
              <select className="sp-select" value={profile.businessCategory||'Vegetables'} onChange={e=>up('businessCategory',e.target.value)}>
                {['Vegetables','Fruits','Seeds','Grains','Spices','Dairy','Equipment','Others'].map(c=><option key={c}>{c}</option>)}
              </select>
            </div>
          </div>
        )}

        {tab === 'address' && (
          <div>
            <div className="sp-card-title">Seller Address</div>
            <div className="sp-input-group"><label className="sp-label">ADDRESS LINE 1</label><input className="sp-input" value={profile.addressLine1||''} onChange={e=>up('addressLine1',e.target.value)} /></div>
            <div className="sp-input-group"><label className="sp-label">ADDRESS LINE 2</label><input className="sp-input" value={profile.addressLine2||''} onChange={e=>up('addressLine2',e.target.value)} /></div>
            <div className="sp-input-row">
              <div className="sp-input-group"><label className="sp-label">CITY</label><input className="sp-input" value={profile.city||''} onChange={e=>up('city',e.target.value)} /></div>
              <div className="sp-input-group"><label className="sp-label">STATE</label>
                <select className="sp-select" value={profile.state||'Tamil Nadu'} onChange={e=>up('state',e.target.value)}>
                  {['Tamil Nadu','Kerala','Karnataka','Andhra Pradesh','Telangana','Maharashtra','Gujarat','Rajasthan','Uttar Pradesh','Others'].map(s=><option key={s}>{s}</option>)}
                </select>
              </div>
            </div>
            <div className="sp-input-group"><label className="sp-label">PINCODE</label><input className="sp-input" type="text" maxLength={6} value={profile.pincode||''} onChange={e=>up('pincode',e.target.value.replace(/\D/,''))} /></div>
          </div>
        )}

        <button className="sp-btn-primary" style={{marginTop:'1.25rem'}} onClick={handleSave} disabled={saving}>
          {saving ? 'Saving…' : 'Save Changes'}
        </button>
      </div>
    </div>
  );
};

export default SellerProfile;